export const contato = {
  "en-US": {
    nome: "Thiago Neves",
    funcao: "Software Engineer",
    email: "thiagomn03@gmail.com",
    linkedin: "thiago-neves-29779031",
    github: "thiagomneves",
    phone: "+55 61 99973-6931",
    whatsapp: "+55 61 99973-6931",
    location: "Asa Norte - Brasília/DF, Brazil",
  },

  "pt-BR": {
    nome: "Thiago Neves",
    funcao: "Engenheiro de Software",
    email: "thiagomn03@gmail.com",
    linkedin: "thiago-neves-29779031",
    github: "thiagomneves",
    phone: "(61) 99973-6931",
    whatsapp: "(61) 99973-6931",
    location: "Asa Norte - Brasília/DF",
  },

  "es-ES": {
    nome: "Thiago Neves",
    funcao: "Ingeniero de Software",
    email: "thiagomn03@gmail.com",
    linkedin: "thiago-neves-29779031",
    github: "thiagomneves",
    phone: "+55 61 99973-6931",
    whatsapp: "+55 61 99973-6931",
    location: "Asa Norte - Brasilia/DF, Brasil",
  }
};

export const habChart = [
  {
    label: "React.js",
    proficiency: 60,
  },
  {
    label: "React Native",
    proficiency: 70,
  },
  {
    label: "Quarkus",
    proficiency: 40,
  },
  {
    label: "Spring Boot",
    proficiency: 50,
  },
  {
    label: "English",
    proficiency: 60,
  },
  {
    label: "Laravel",
    proficiency: 80,
  },
  {
    label: "Express.js",
    proficiency: 50,
  },
  {
    label: "Angular",
    proficiency: 30,
  },
  {
    label: "SQL",
    proficiency: 85,
  },
];



// const resumo = `Trabalho com programação desde 2008, desde 2015 como programador web, tanto de frontend como de backend.
// Atualmente atuo como desenvolvedor mobile no Banco do Brasil utilizando tecnologia React Native e metodologias ágeis`

export const summary = {
  "en-US": `Experienced backend developer specializing in Java with Quarkus, Kubernetes, and cloud-native technologies. Skilled in building scalable microservices, automating CI/CD pipelines, and collaborating in agile teams. Passionate about delivering high-quality software solutions.`,
  "pt-BR": `Desenvolvedor backend experiente, especializado em Java com Quarkus, Kubernetes e tecnologias cloud-native. Habilidade na construção de microsserviços escaláveis, automação de pipelines de CI/CD e colaboração em equipes ágeis. Apaixonado por entregar soluções de software de alta qualidade.`,
  "es-ES": `Desarrollador backend con experiencia, especializado en Java con Quarkus, Kubernetes y tecnologías cloud-native. Experiencia en la construcción de microservicios escalables, automatización de pipelines de CI/CD y colaboración en equipos ágiles. Apasionado por ofrecer soluciones de software de alta calidad.`
};

export const skills = [
  "React",
  "React Native",
  "Laravel",
  "Express.js",
  "Nest.js",
  "Angular",
  "Quarkus",
  "Spring",
  "Linux",
  // "SASS",
  // "JWT",
  "MySQL",
  "Postgres",
  "Sqlite",
  "MongoDB",
  // "ShellScript",
  // "Strapi",
];

